import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { BoxCentered } from "../BoxCentered";
import { BigAlertIcon } from "../icons/big_alert";

export function ErrorMessage({ title, children }: Readonly<{ title?: string; children: React.ReactNode }>) {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <BoxCentered>
            <BigAlertIcon />
          </BoxCentered>
        </Grid>
        <Grid item xs={12}>
          <BoxCentered>
            <Typography variant="h2" color="error">
              {title}
            </Typography>
          </BoxCentered>
        </Grid>
      </Grid>
      {children}
    </Box>
  );
}
